import DeliveryTicket from "pages/delivery-ticket";
import DeliveryZoneDetail from "pages/delivery-ticket/details";

const routes = [
  //delivery zone list
  {
    path: `/delivery-ticket`,
    exact: true,
    auth: true,
    component: DeliveryTicket,
  },
  //delivery zone details
  {
    path: `/delivery-ticket/:regionId`,
    exact: true,
    auth: true,
    component: DeliveryZoneDetail,
  },
];

export default routes;
